import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getEvent = (state: IStore) => state.event.event;
const getIsFetching = (state: IStore) => state.event.isFetching;
const getIsFetchFailed = (state: IStore) => state.event.isFetchFailed;

const getEventWithSortedPerformances = createSelector(
  [getEvent],
  (event) => {
    if (!event || !event.performances) {
      return event;
    }
    const sortedPerformances = event.performances.sort((a, b) => (a.date < b.date ? -1 : 1));
    return { ...event, performances: sortedPerformances };
  },
);

const getPerformances = createSelector(
  [getEvent],
  (event) => {
    return event && event.performances ? event.performances : [];
  },
);

const getMinPrice = createSelector(
  [getPerformances],
  (performances) => {
    let minPrice = Number.MAX_VALUE;
    performances.map(p => 
      minPrice = p.availabilityStatus !== 0 && p.minPrice < minPrice ? p.minPrice : minPrice);
    return minPrice === Number.MAX_VALUE ? null : minPrice;
  },
);

const getFirstDate = createSelector(
  [getPerformances],
  (performances) => {
    const maxMs = 8640000000000000;
    let minMs = maxMs;

    performances.map(p => {
      const ms = p.date.getTime();
      minMs = ms < minMs ? ms : minMs;
    });
    
    return minMs === maxMs ? null : new Date(minMs);
  },
);

const getLastDate = createSelector(
  [getPerformances],
  (performances) => {
    const minMs = -8640000000000000;
    let maxMs = minMs;

    performances.map(p => {
      const ms = p.date.getTime();
      maxMs = ms > maxMs ? ms : maxMs;
    });

    return maxMs === minMs ? null : new Date(maxMs);
  },
);

export {
  getIsFetching,
  getIsFetchFailed,
  getMinPrice,
  getFirstDate,
  getLastDate,
  getEventWithSortedPerformances,
};


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/Redux/selectors.tsx